import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { environment } from 'src/environments/environment';
import { enableProdMode } from '@angular/core';
import { appConfigPromise } from './app/app.config';

if (environment.production) {
  enableProdMode();
}

// Wait for the config promise to resolve before bootstrapping
appConfigPromise.then(config => {
  bootstrapApplication(AppComponent, config)
    .catch((err) => console.error(err));
});